<div class="form-container">
  <div class="cardLayout">
    <ion-row class="align-center header-row">
      <!-- Left: Title -->
      <ion-col size="12" size-md="4">
        <div class="formLabelSemiBoldfs16 m-10">Allocate Assets</div>
      </ion-col>

      <!-- Right: Refresh + Close -->
      <ion-col
        size="12"
        size-md="8"
        class="mt-10"
        style="display: flex; justify-content: flex-end; gap: 16px; align-items: center;"
      >
        <!-- Refresh button -->
        <span
          class="fs-20 material-icons btn-reset"
          style="cursor: pointer;"
          [class.clicked]="isClicked"
          (click)="resetGrid()"
          (animationend)="isClicked = false"
        >
          refresh
        </span>

        <!-- Close icon -->
        <img
          [mat-dialog-close]
          class="cp"
          src="././assets/icon/close_icon.png"
          style="width: 20px; height: 20px;"
        />
      </ion-col>
    </ion-row>

    <!-- Scrollable body -->
    <div class="modal-body scrollable-content">
   
        <div class="card employeeTab">
          <div class="card-body">
            <mat-sidenav-container class="sidenav-container rounded">
              <mat-sidenav-content>
                <div class="ag-grid-wrapper">
                  <ag-grid-angular
                    class="ag-theme-quartz custom-ag-grid improved-grid"
                    [rowData]="AllAssetListingData"
                    [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef"
                    [components]="components"
                    [context]="gridContext"
                    (gridReady)="onGridReady($event)"
                    (cellClicked)="onCellClicked($event)"
                    [pagination]="pagination"
                    [paginationPageSize]="paginationPageSize"
                    [paginationPageSizeSelector]="paginationPageSizeSelector"
                    [domLayout]="'normal'"
                    [rowHeight]="60"
                    [localeText]="{ noRowsToShow: 'No Data Found' }"
                  ></ag-grid-angular>
                </div>
              </mat-sidenav-content>
            </mat-sidenav-container>
          </div>
        </div>
       
    </div>
  </div>
</div>
